var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 160,
    width: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h160v160H0z",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.524 44.86l-.102 94.13-25.22-8.202V20.146l32.192 8.511C114 34.196 126.61 44.961 126.406 63.83c-.205 21.944-10.355 30.761-30.142 25.02V45.575c0-5.23-9.74-5.536-9.74-.717z",
    fill: "#de0029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.616 112.533l-11.893 4c-7.69 2.667-14.251-3.588-7.177-6.153l5.74-2.05-21.632-6.87c-6.664 2.256-12.919 7.076-12.508 13.844.41 6.869 16.096 8.51 28.195 10.459 11.277 1.845 21.53.82 30.86-2.462v-7.076zm37.01 26.457l22.043-7.691-22.247-7.074v14.251z",
    fill: "#f3c202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.27 118.38l.41-.103c9.638-3.383 13.739-8.102 12.714-12.51-1.64-7.382-13.43-11.382-31.578-12.715-13.02-.922-25.835 1.948-38.343 6.254l-2.051.719 22.453 6.973 13.123-4.41c13.738-2.563 19.275 1.948 6.049 6.153l-6.562 2.254zM61.201 85.773l-9.945 3.383 9.945 3.076z",
    fill: "#326db3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.67 131.299l36.6-12.919-23.785-7.385-35.063 11.998v1.232zM61.2 108.637l-11.585 3.897 11.585 3.691zm25.22 6.052v-14.664l22.454 6.973zm-50.134-6.358l24.914-8.921v-7.178l-9.945-3.076-36.09 12.202c-.102 0-.307.101-.512.101z",
    fill: "#00aa9e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystation);
export default __webpack_public_path__ + "static/media/playstation.c7039be14e5ca1b515a369c69fc009e6.svg";
export { ForwardRef as ReactComponent };